import { App } from 'vue'
import router from '@/router'
import { regAxios } from './install'
import { message } from 'ant-design-vue'
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import utils from '@/utils/index'
import * as util from '@/utils/encryption/index';
import pinia from '@/store'
import { userStore } from '@/store/modules/user'
import Cookies from 'js-cookie';
const store = userStore(pinia);

// 创建axios实例
const request = axios.create({
  baseURL: '',
  timeout: 60000
})
let currentLang = localStorage.getItem('PAI-language') || localStorage.getItem('lang');
if(currentLang === 'zh-CN' || currentLang === 'zh-TW'){
  currentLang = currentLang.replace('-','_');
}
request.defaults.headers.common['Accept-Language'] = currentLang||'zh_CN';
/**
 * @desc: 异常拦截处理器
 * @param { Object } error 错误信息
 */
const errorHandler = (error: AxiosError): AxiosError | Promise<AxiosError> => {
  // 判断是否显示公共提示， true|显示公共提示，false｜不显示公共提示
  if(error.config && error.config.headers && (!error.config.headers.hasOwnProperty('showError') || error.config.headers.showError)){
    message.error({
      content:error.message,
      class:'error-message',
    })
  }
  return Promise.reject(error)
}
/**
 * @desc: 请求发送前拦截
 * @param { Object } config 配置参数
 */
request.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
  // 请求头 新增 租户名称
  if ((window as any).serverConfig.IS_MULTI_TENANCY) {
    let tenantName = localStorage.getItem('tenantName');
    request.defaults.headers.common['tenantName'] = tenantName
  }
  // 免token接口
  if (config.url && utils.requestIsNotToken(config.url)) {
    config = requestEncryptionConfig(config, null);
    return config;
  }
  let paiToken: any = localStorage.getItem('PAI-token');
  if (paiToken) {
    paiToken = JSON.parse(paiToken);
    // 处理加密
    config = requestEncryptionConfig(config, paiToken);
    // 验证token是否失效，如果失效需要重新去服务端拿一次token，然后更新token
    //当前时间
    const curTime = new Date().getTime();
    // 上次登录成功时间
    const loginTime = localStorage.getItem('Login-time');
    // token有效期，因为单位为‘秒’，所以需要转化为毫秒
    const expiresIn = paiToken['expires_in'] * 1000;
    if (!loginTime|| ((Number(loginTime) + Number(expiresIn) - 7200000) >= curTime)) {
      // 没有登录或者在有效期内
      if (store.requestStatus !== 'requestToken') {
        // 添加验证paiToken 防止登出时间正在删除token 前端报错
        if(paiToken.hasOwnProperty('access_token') && !config.headers.Authorization){
          config.headers.Authorization = 'Bearer ' + paiToken.access_token;
        }
      }
      return config;
    }
  }
  if ((window as any).serverConfig.hasOwnProperty('SSO_LOGIN_URL') && (window as any).serverConfig.SSO_LOGIN_URL) {
    location.href = (window as any).serverConfig.SSO_LOGIN_URL;
    // 必须要return防止 cancelToken 错误
    return config;
  } else {
    // token 过期或者无token 取消当前请求
    let cancel: any = null;
    // 设置cancelToken对象
    config.cancelToken = new axios.CancelToken(function(c) {
      cancel = c;
    })
    // 取消请求
    if (cancel) {
      localStorage.removeItem('PAI-token');
      localStorage.removeItem('Login-time');
      localStorage.removeItem('PAI-account');
      Cookies.remove('loginname');
      cancel()
    }
    if ((window as any).serverConfig.IS_SSO) {
      Cookies.remove('tokenId');
      Cookies.remove('loginname');
      location.reload();
    }else{
      // 跳转到登录页面
      router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } });
    }
    // 必须要return防止 cancelToken 错误
    return config;
  }
}, errorHandler)
/**
 * @FunctionName: 处理请求参数
 * @param {*} config
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 09:38:35
 * @Modification history:
 * @Description:
 */
export function requestEncryptionConfig(config:any, paiToken:any) {
  // 过滤不加密接口配置
  // "NOT_INTERFACE_ENCRYPTION":'"query|getProcessById"'
  const not_encryption = (window as any).serverConfig.NOT_INTERFACE_ENCRYPTION;
  if (not_encryption) {
    const notList = not_encryption.split('|');
    for (const item of notList) {
      if (config.url.indexOf(item) > -1) {
        return config;
      }
    }
  }
  // # 设置要加密的服务
  // "IS_SERVICE_ENCRYPTION":'"Object|usre-service"'
  const service_encryption = (window as any).serverConfig.IS_SERVICE_ENCRYPTION;
  if (service_encryption) {
    const serviceList = service_encryption.split('|');
    let result = true;
    for (const item of serviceList) {
      // 包含 /服务名/ 或者 服务名/开头
      if (config.url.indexOf(`/${item}/`) > -1 || config.url.startsWith(item)) {
        result = false;
      }
    }
    if (result) {
      return config;
    }
  }
  // # 设置指定接口加密
  // "IS_INTERFACE_ENCRYPTION": '"query|getProcessById"'
  const interface_encryption = (window as any).serverConfig.IS_INTERFACE_ENCRYPTION;
  if (interface_encryption) {
    const interfaceList = interface_encryption.split('|');
    let result = true;
    for (const item of interfaceList) {
      if (config.url.indexOf(item) > -1) {
        result = false;
      }
    }
    if (result) {
      return config;
    }
  }
  // 加密等级 1
  if (!(window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') || (window as any).serverConfig.ENCRYPT_LEVEL === 1) {
    config = encryption1(config, paiToken);
  }
  // 加密等级 2
  if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') && (window as any).serverConfig.ENCRYPT_LEVEL === 2) {
    config = encryption2(config, paiToken);
  }
  // 加密等级 3
  if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') && (window as any).serverConfig.ENCRYPT_LEVEL === 3) {
    config = encryption3(config, paiToken);
  }
  return config;
}
/**
 * @FunctionName: 加密等级 1-简单
 * @param {*} config
 * @param {*} paiToken
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-05 09:53:00
 * @Description:
 */
function encryption1(config:any, paiToken:any) {
  // 请求加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_REQUEST !== false)) {
    // 全部加密 或者 filter 加密
    if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') ||
      ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') &&
        (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_ALL !== false) ||
      (config.data && config.data.hasOwnProperty('filter')) ||
      (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy)) {
      // 公钥
      let secretKey = null;
      // 时间戳
      let timestamp = null;
      let loginName = null;
      // 处理MIX 获取 随机加密公钥
      if ((window as any).serverConfig.ENCRYPTION_MODE === 'MIX') {
        if (paiToken && paiToken.paiCoreUserDetail && paiToken.paiCoreUserDetail.loginName) {
          loginName = paiToken.paiCoreUserDetail.loginName;
        }
        timestamp = Date.parse(new Date().toString());
        timestamp = util.strLastZero(timestamp);
        // RSA 加密获取公钥
        secretKey = util.encrypt(timestamp + '|' + loginName, secretKey, 'RSA');
      }
      // 处理header
      // 请求参数加密方式
      config.headers['encryptReqtMethod'] = (window as any).serverConfig.ENCRYPTION_MODE;
      // 判断是否有加密公钥
      if (secretKey) {
        config.headers['encryptReqtKey'] = secretKey;
      }
      // 处理 orderBy
      if (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy) {
        // 时间搓 作为key
        config.headers.orderBy = util.encrypt(config.headers.orderBy, timestamp, (window as any).serverConfig.ENCRYPTION_MODE);
      }
      if (config.method.toLocaleLowerCase() !== 'get') {
        // 参数加密
        if (config.data) {
          // verifySign
          if (paiToken && (window as any).serverConfig.ENCRYPTION_MODE !== 'MIX' && paiToken.paiCoreUserDetail && paiToken.paiCoreUserDetail.loginName) {
            config.data['verifySign'] = paiToken.paiCoreUserDetail.loginName;
          }
          config.data = { ['encryptData']: util.encrypt(JSON.stringify(config.data), timestamp, (window as any).serverConfig.ENCRYPTION_MODE) };
        }
      }
      if (config.method.toLocaleLowerCase() === 'get') {
        // verifySign
        if (paiToken && (window as any).serverConfig.ENCRYPTION_MODE !== 'MIX' &&
            paiToken.paiCoreUserDetail && paiToken.paiCoreUserDetail.loginName) {
          if (!config.params) {
            config.params = {};
          }
          config.params['verifySign'] = paiToken.paiCoreUserDetail.loginName;
        }
        // 要加密的Get 接口配置
        encryptionGet(config, timestamp);
      }
    }
  }
  // 响应加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_RESPONSE !== false)) {
    // 响应数据 加密方式
    config.headers['encryptRespMethod'] = (window as any).serverConfig.ENCRYPTION_MODE;
  }
  return config;
}
/**
 * @FunctionName: 加密等级 2--中等
 * @param {*} config
 * @param {*} paiToken
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-05 09:53:00
 * @Description:
 */
function encryption2(config:any, paiToken:any) {
  // 请求加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_REQUEST !== false)) {
    // 全部加密 或者 filter 加密
    if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') ||
      ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') &&
        (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_ALL !== false) ||
      (config.data && config.data.hasOwnProperty('filter')) ||
      (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy)) {
      let secretKey = null;
      let encryptKey = '';
      // 处理MIX 获取 随机加密公钥
      if ((window as any).serverConfig.ENCRYPTION_MODE === 'MIX') {
        const enPrame = util.getEncryptionKey(paiToken);
        encryptKey = enPrame.key;
        // RSA 加密获取公钥
        secretKey = util.encrypt(enPrame.key, secretKey, 'RSA');
      }
      // 处理header
      // 请求参数加密方式
      config.headers['m'] = (window as any).serverConfig.ENCRYPTION_MODE;
      // 判断是否有加密公钥
      if (secretKey) {
        config.headers['k'] = secretKey;
      }
      // 处理 orderBy
      if (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy) {
        // 时间搓 作为key
        config.headers.orderBy = util.encrypt(config.headers.orderBy, encryptKey, (window as any).serverConfig.ENCRYPTION_MODE);
      }
      if (config.method.toLocaleLowerCase() !== 'get') {
        // 参数加密
        if (config.data) {
          // verifySign
          if (paiToken && (window as any).serverConfig.ENCRYPTION_MODE !== 'MIX' && paiToken.paiCoreUserDetail && paiToken.paiCoreUserDetail.loginName) {
            config.data['verifySign'] = paiToken.paiCoreUserDetail.loginName;
          }
          config.data = { ['d']: util.encrypt(JSON.stringify(config.data), encryptKey, (window as any).serverConfig.ENCRYPTION_MODE) };
        }
      }
      if (config.method.toLocaleLowerCase() === 'get') {
         // verifySign
        if (paiToken && (window as any).serverConfig.ENCRYPTION_MODE !== 'MIX' &&
            paiToken.paiCoreUserDetail && paiToken.paiCoreUserDetail.loginName) {
          if (!config.params) {
            config.params = {};
          }
          config.params['verifySign'] = paiToken.paiCoreUserDetail.loginName;
        }
        // 要加密的Get 接口配置
        encryptionGet(config, encryptKey);
      }
    }
  }
  // 响应加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_RESPONSE !== false)) {
    // 响应数据 加密方式
    config.headers['encryptRespMethod'] = (window as any).serverConfig.ENCRYPTION_MODE;
  }
  return config;
}
/**
 * @FunctionName: 加密等级 3--困难
 * @param {*} config
 * @param {*} paiToken
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-05 09:53:00
 * @Description:
 */
function encryption3(config:any, paiToken:any) {
  // 请求加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_REQUEST !== false)) {
    // 全部加密 或者 filter 加密
    if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') ||
      ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') &&
        (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_ALL !== false) ||
      (config.data && config.data.hasOwnProperty('filter')) ||
      (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy)) {
      let enPrame = util.getEncryptionKey(paiToken);
      // 处理 orderBy
      if (config.headers.hasOwnProperty('orderBy') && config.headers.orderBy) {
        // 时间搓 作为key
        config.headers.orderBy = util.encrypt(config.headers.orderBy, enPrame.key, (window as any).serverConfig.ENCRYPTION_MODE);
      }
      if (config.method.toLocaleLowerCase() !== 'get') {
        // 参数加密
        if (config.data) {
          config.data = { [enPrame.uuid]: util.encrypt(JSON.stringify(config.data), enPrame.key, (window as any).serverConfig.ENCRYPTION_MODE) };
        }
      }
      if (config.method.toLocaleLowerCase() === 'get') {
        if (!config.params) {
          config.params = {};
        }
        // 要加密的Get 接口配置
        encryptionGet(config, enPrame.key, enPrame.uuid);
      }
    }
  }
  // 响应加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_RESPONSE') &&
      (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_RESPONSE !== false)) {
    // 响应数据 加密方式
    config.headers['encryptRespMethod'] = (window as any).serverConfig.ENCRYPTION_MODE;
  }
  return config;
}
/**
 * @FunctionName: 要加密的Get 接口配置
 * @param {*} config
 * @param {*} eKey
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-21 17:45:58
 * @Description:
 */
function encryptionGet(config:any, eKey:string, uuid:string='') {
  // "IS_GET_INTERFACE_ENCRYPTION":'"query|getProcessById"'
  let get_encryption = (window as any).serverConfig.IS_GET_INTERFACE_ENCRYPTION;
  let isEncrypt = false;
  if (get_encryption) {
    get_encryption = get_encryption.split('|');
    for (const item of get_encryption) {
      if (config.url.indexOf(item) > -1) {
        isEncrypt = true;
        let index = config.url.indexOf(item);
        index += item.length + 1;
        let pUrl = config.url.substr(index, config.url.length - 1);
        let pObj = null;
        // 单独处理 URL上面问号参数
        if (pUrl.indexOf('?') > -1) {
          pUrl = pUrl.substr(0, pUrl.indexOf('?'));
          pObj = util.getRequestParam(config.url);
          if (pObj) {
            config.params = {
              ...pObj,
              ...config.params
            };
          }
        }
        pUrl = util.encrypt(pUrl, eKey, (window as any).serverConfig.ENCRYPTION_MODE);
        pUrl = pUrl.replace(/\//g, '|');
        pUrl = encodeURIComponent(pUrl);
        let url = config.url.substr(0, index);
        config.url = `${url}${pUrl}`;
        break;
      }
    }
    if (isEncrypt) {
      if (config.params) {
        let keys = Object.keys(config.params);
        for (const key of keys) {
          let eStr = config.params[key];
          config.params[key] = util.encrypt(eStr, eKey, (window as any).serverConfig.ENCRYPTION_MODE);
        }
      }
      config.params['d'] = uuid;
    }
  }
}
/**
 * @desc: 服务端响应后拦截
 * @param { Object } response 返回的数据
 */
request.interceptors.response.use((response: AxiosResponse): AxiosResponse | Promise<AxiosResponse> => {
  // 判断是否接口是否加密
  response = responseEncryptionConfig(response);
  if (response.status === 401) {
    if ((window as any).serverConfig.IS_SSO) {
      localStorage.removeItem('PAI-token');
      localStorage.removeItem('Login-time');
      localStorage.removeItem('PAI-account');
      Cookies.remove('tokenId');
      Cookies.remove('loginname');
      location.reload();
    }else{
      // 登录失效
      router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } })
    }
    return Promise.reject(response)
  } else {
    const res = response.data;
    if(response.headers &&
      response.headers['content-type'] &&
      response.headers['content-type'].indexOf('application/vnd.ms-excel')>-1 &&
      !response.data.hasOwnProperty('responseCode')){
      return response;
    }
    const errorStatus = [
      // 授权错误
      '600',
      // 无效的客户端
      '601',
      // 未授权的客户端
      '602',
      // 用户名或密码错误
      '603',
      // 无效的scope
      '604',
      // token过期
      '605',
      // token格式错误
      '606',
      // 无效的请求
      '607',
      // 重定向错误
      '608',
      // 不支持的responseType
      '609',
      // 拒绝访问
      '610'
    ];
    //  判断是否显示公共提示， true|显示公共提示，false｜不显示公共提示
    let showError = true;
    if(response.config && response.config.headers && response.config.headers.hasOwnProperty('showError')){
      showError = response.config.headers.showError;
    }
    // 数据请求正常
    if ((res as any).responseCode === '100') {
      return res;
      // 系统异常，联系管理员
    } else if ((res as any).responseCode === '300') {
      if (showError) {
        const mag:any = [];
        //key数组
        const key = [];
        //错误的类型数组
        const type = [];
        for (const item of res.messageList) {
          mag.push(item.message);
          if (item && item.key) {
            key.push(item.key);
          }
        }
        if (key.length > 0) {
          for (const item of key) {
            if (item && item.indexOf('_') > -1) {
              type.push(item.split('_')[1]);
            }
          }
        }
        //定义公共提示方法
        const notice = function (val:any) {
          const mes = mag.join(',');
          // message.error(mes + ' logId:' + res.logId)
          message.error({
            content:mes,
            class:'error-message',
          })
          // message({
          //   message: mes + ' logId:' + res.logId,
          //   type: val,
          //   duration: 2000
          // });
        };

        if (type.indexOf('ERROR') > -1) {
          notice('error');

        } else if (type.indexOf('ERROR') === -1 && type.indexOf('INFO') === -1 && type.indexOf('WARN') > -1) {
          notice('warning');

        } else if (type.indexOf('ERROR') === -1 && (type.indexOf('WARN') > -1 || type.indexOf('INFO') > -1)) {
          notice('info');

        } else {
          notice('error');
        }
      }
      return showError ? Promise.reject('error') : Promise.reject(res);
      // 60* 错误
    } else if (errorStatus.includes((res as any).responseCode)) {
      // 605|token过期, 606|token格式错误
      if (res.responseCode === '605' || res.responseCode === '606') {
        // 通过浏览器的 localStorage 判断登出状态
        // let logoutStart = auth.getStorageByKey('logoutStart');
        // if (!logoutStart) {
        //   // 记录登出状态 
        //   auth.setStorageByKey('logoutStart', 1);
        //   // 提示
        //   MessageBox.confirm(i18n.t(`httpMsg.${res.responseCode}`), i18n.t('common.tips'), {
        //     confirmButtonText: i18n.t('common.logback'),
        //     cancelButtonText: i18n.t('common.cancel'),
        //     type: 'warning'
        //   }).then(() => {
        //     auth.logout();
        //   }).catch(() => {
        //     auth.removeStorageByKey('logoutStart');
        //   });
        // }
        if ((window as any).serverConfig.IS_SSO) {
          localStorage.removeItem('PAI-token');
          localStorage.removeItem('Login-time');
          localStorage.removeItem('PAI-account');
          Cookies.remove('tokenId');
          Cookies.remove('loginname');
          location.reload();
        }else{
          // 登录失效
          router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } })
        }
      } else {
        if (showError) {
          // Notification({
          //   message: res.messageList[0].key + ' logId:' + res.logId,
          //   type: 'error',
          //   duration: 2000
          // });
        }
        // 除开605\606  的其他60*状态
        return showError ? Promise.reject('error') : Promise.reject(res);
      }
    }
    // 注意只是以防万一状态码不规范(后台直接返回数据，没有返回状态码的情况)
    return res;
  }
}, errorHandler)
/**
 * @FunctionName: 处理接口响应数据
 * @param {*} response
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 09:45:00
 * @Modification history:
 * @Description:
 */
export function responseEncryptionConfig(response:any) {
  // 判断是否接口是否加密
  if (response.headers.encryptrespmethod) {
    // 公钥
    let secretKey = null;
    // 处理MIX
    if (response.headers.encryptrespmethod === 'MIX') {
      // RSA 解密获取公钥
      secretKey = util.decrypt(response.headers.encryptrespkey, null, 'RSA');
    }
    if (response.headers.encryptrespmethod) {
      if (response.data.encryptData) {
        const str = util.decrypt(response.data.encryptData, secretKey, response.headers.encryptrespmethod);
        response.data = JSON.parse(str);
      }
    }
  }
  return response;
}
export const globalAxios = {
  install(app: App, config: any) {
    request.defaults.baseURL = config.BASE_API
    app.use(regAxios, request)
  }
}
export default request